import { useContext, useEffect, useRef } from "react";

import { DiscoveryContext } from "./discovery-context";
import api from "../../BrandOnBoarding/api";
import { AuthContext } from "../../context/auth-context";

export default function useGenerateProductTaxonomies() {
  const discoveryCtx = useContext(DiscoveryContext);
  const abortControllerRef = useRef();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      discoveryCtx.updateCategoryTaxonomies([]);
    }
  }, [discoveryCtx.abort_launch]);

  async function generateProductTaxonomies(category) {
    abortControllerRef.current = new AbortController();
    try {
      const response = await api.post(
        "/metrics/product-dimensions",
        {
          llm: "gpt-4o",
          category: category,
          language_id: discoveryCtx.language == "it" ? 2 : 1,
          customer_id: user.customer_id
        },
        {
          signal: abortControllerRef.current.signal,
        }
      );
      discoveryCtx.updateCategoryTaxonomies(response.data.data);
    } catch (error) {
      console.error("Error getting taxonomies:", error);
    }
  }

  return {
    custom_taxonomies: discoveryCtx.category_taxonomies,
    generateProductTaxonomies,
  };
}
